import { QueryClient, queryOptions, useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { Bo } from '@teetsh/app/src/types/bo';
import { useQueryData } from '@teetsh/app/src/queries/useQueryData';
import { requireUserSession } from '@teetsh/app/src/queries/requireUserSession';

export const BO_KEY = 'bo';

function getBos() {
  const requestURL = '/bos';

  return request(requestURL, {
    method: 'GET',
  }).then<Bo[]>(({ data }) => data || []);
}

function boQuery() {
  return queryOptions({
    queryKey: [BO_KEY, 'list'],
    queryFn: getBos,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60,
  });
}

export const loader = (queryClient: QueryClient) => async () => {
  await requireUserSession();
  return queryClient.ensureQueryData(boQuery());
};

export default function useBos() {
  return useQuery(boQuery());
}

export function useBosData() {
  return useQueryData(boQuery());
}
